import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const dashboardIconButton: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_DashboardIconButton_dataBinding_panelTitle',
    helpId: '82b7ad7d-5e28-4b5f-8d47-63225b36794f',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'DashboardIconButtonRole',
      bindings: [
        {
          title: 'dsgnsys_DashboardIconButton_dataBinding_tooltip_label',
          prop: 'tooltip',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.richText,
            FieldType.email,
          ],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardIconButton_dataBinding_link_label',
          prop: 'link',
          supportedFieldTypes: [FieldType.url],
          defaultFieldType: FieldType.url,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
